import { memo } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import {
  Printer, ScanLine, BookOpen, Layers, Package, Briefcase,
} from "lucide-react";

const SHOP_SERVICES = [
  {
    icon: Printer,
    title: "Photocopie & Impression",
    desc: "Couleur et N&B, A4/A3, recto-verso. Reliure, plastification A4/A3.",
    iconBg: "bg-blue-100",
    iconColor: "text-blue-600",
  },
  {
    icon: ScanLine,
    title: "Scan & Numérisation",
    desc: "Documents, photos anciennes, diapos. Format PDF haute définition envoyé par email.",
    iconBg: "bg-emerald-100",
    iconColor: "text-emerald-600",
  },
  {
    icon: BookOpen,
    title: "Reliure & Plastification",
    desc: "Reliure à spirale pour rapports et thèses. Plastification de documents importants.",
    iconBg: "bg-amber-100",
    iconColor: "text-amber-600",
  },
  {
    icon: Package,
    title: "Point Relais 📦",
    desc: "Dépôt et retrait de colis. Sans rendez-vous, du lundi au samedi.",
    iconBg: "bg-purple-100",
    iconColor: "text-purple-600",
  },
  {
    icon: Briefcase,
    title: "Consigne bagages 🧳",
    desc: "À 200 m de la gare SNCF. Pratique pour les voyageurs. Tarif horaire ou journalier.",
    iconBg: "bg-red-100",
    iconColor: "text-red-600",
  },
  {
    icon: Layers,
    title: "Services pros B2B",
    desc: "Contrats maintenance, parc informatique, flottes mobiles. Devis sous 24 h.",
    iconBg: "bg-slate-100",
    iconColor: "text-slate-700",
  },
];

export const ShopServicesSection = memo(() => (
  <section className="section-padding bg-slate-50" data-testid="shop-services-section">
    <div className="container-custom max-w-6xl">
      <div className="text-center mb-10">
        <Badge className="bg-red-100 text-red-700 px-4 py-2 mb-4 hover:bg-red-100">
          Services boutique
        </Badge>
        <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
          Au-delà de la réparation
        </h2>
        <p className="text-lg text-slate-600 max-w-3xl mx-auto">
          Mediastore propose une gamme complète de services boutique à 200 m de la gare de Niort :
          impression, scan, reliure, plastification, point relais et consigne bagages.
        </p>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {SHOP_SERVICES.map((s) => {
          const Icon = s.icon;
          return (
            <Card key={s.title} className="border border-slate-100 hover:shadow-md transition-shadow">
              <CardContent className="p-5">
                <div className={`w-12 h-12 rounded-lg ${s.iconBg} flex items-center justify-center mb-3`}>
                  <Icon className={`h-6 w-6 ${s.iconColor}`} />
                </div>
                <h3 className="font-bold text-slate-900 mb-1">{s.title}</h3>
                <p className="text-sm text-slate-600 leading-relaxed">{s.desc}</p>
              </CardContent>
            </Card>
          );
        })}
      </div>
    </div>
  </section>
));

ShopServicesSection.displayName = "ShopServicesSection";
